export const setProductsPagination = {
  SET_PRODUCTS_PAGINATION(state, payload) {
    state.productsPagination = payload
  }
}
